var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RiseupHeader',[_c('img',{attrs:{"src":require('@/assets/hamburger.svg')},on:{"click":function($event){$event.stopPropagation();return _vm.openNavBar($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }